export default function formatFullDate(isoDateString) {
  const date = new Date(isoDateString);

  const options = {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  return date.toLocaleDateString('pt-BR', options);
}
